import type { FamilyParentSummary } from '~entities/family/model/family.type';

export const formatFamilyParentLabel = (
  parent: FamilyParentSummary | null | undefined,
  parentId: string,
): string => {
  if (!parent) return parentId;
  const composed = [parent.firstName, parent.lastName]
    .filter(Boolean)
    .join(' ')
    .trim();
  const name = (parent.name || composed).trim();
  if (name) return name;
  if (parent.email) return parent.email;
  return parentId;
};
